import { DriverData } from '../../../../types/interfaces'
import { client } from '../../client'

export class DriversService {
  public async getDriverProfile() {
    return client.get<DriverData>('/drivers')
  }
}
